module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAwCAMAAACbi/xqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA5UExURfX19ecuPPvX2/e7wN/f3+EAEv////X19ff399/f3/Wlq/GFjuMUJf3m5+1oc+lNWf7z9PnN0fOVnQbBy+oAAAAKdFJOU+X////b///j5d1DDnRoAAAAqElEQVRIx+3WSw7DIAxFUdvErQLkQ/a/2EodNSoePPrUEXcBR8oHG1mehBaRByGZzGTunZaSnb8xVtTfabFhZtv9o30bY1L1WzWNMJd/deFM9k4ZZZp3ayCjfUYxJntQhhiNGEWY5mEGMCVmCsAcMXMAjMaMAkyNmfp/hvRQpFdM+uDG+f1Ih4F1NEmDgjW2SEOUNdJZC4a17ljLl3YVmLetyQTMKoTWF3KlSdKPxC9cAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/japan.png
// module id = lmhM
// module chunks = 34